import React from "react";
import { ItemMasterForm } from "./ItemMasterForm";

const SAPItemMaster =()=>{
    return(
        <>
        <ItemMasterForm/>
        </>
    )
};

export default SAPItemMaster;